import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { TransferEmployerCloseOfficeService } from '../transfer-employer-close-office.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { SelectEmployeesToManageRequestModel } from '../../../model/selectEmployeesToManageRequestModel';
import { GetEmployeesAndOfficesToSelectToManageModel } from '../../../model/getEmployeesAndOfficesToSelectToManageModel';
import { EmployeeSelectableListModel } from '../../../model/employeeSelectableListModel';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SearchEmployeesToManageRequestModel } from '../../../model/searchEmployeesToManageRequestModel';
import { MessageModel } from '../../../model/models';
import { SearchEmployeesToManageResponseModel } from '../../../model/searchEmployeesToManageResponseModel';
import * as $ from 'jquery';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { SelectEmployeesToManageResponseModel } from '../../../model/selectEmployeesToManageResponseModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IndividualLicenseComponent } from '../../view-pending-approvals/individual-license/individual-license.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { WorkflowStepModel } from '../../../model/workflowStepModel';


@Component({
  selector: 'app-select-employees',
  templateUrl: './select-employees.component.html',
  styleUrls: ['./select-employees.component.css']
})
export class SelectEmployeesComponent implements OnInit, OnDestroy {

  title: string = "";
  notifysearchEmployeesToManageResponseSubscription = new Subscription();
  notifySelectEmployeesRequestModelSubscription = new Subscription();
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  updatedWorkflow : WorkflowModel = new WorkflowModel();
  selectEmployeesModel: SelectEmployeesToManageRequestModel = new SelectEmployeesToManageRequestModel();
  selectedAll: any;
  userMessages: Array<MessageModel> = [];
  sever: boolean = false;
  transfer: boolean = false;
  severSubmitted : boolean = false;
  transferSubmitted : boolean = false;
  searchEmployeesToManageResponseModel: SearchEmployeesToManageResponseModel = null;
  selectEmployeesToManageResponseModel : SelectEmployeesToManageResponseModel ;
  /**
     * List of employees to select
     */
  EmployeeList: Array<EmployeeSelectableListModel> = [];
  /**
   * List of offices to select
   */
  OfficeList: Array<OfficeSelectableListModel> = [];

  constructor(private transferEmployerCloseOfficeService: TransferEmployerCloseOfficeService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private spinner: SpinnerService,
    private modalService: NgbModal,
    private router: Router) {

    this.notifySelectEmployeesRequestModelSubscription = this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().subscribe(selectEmplReqData => {
      this.selectEmployeesModel = selectEmplReqData;
    });

    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
    }

    this.notifysearchEmployeesToManageResponseSubscription = this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel()
      .subscribe(searchEmployeesToManageResp => {
        this.searchEmployeesToManageResponseModel = searchEmployeesToManageResp;
        this.workflow = searchEmployeesToManageResp.Workflow;
        

      });

  }
  ngOnInit() {

    this.selectEmployeesModel.WorkflowID = this.workflow.WorkflowID;
    this.selectEmployeesModel.CurrentStepIndex = this.workflow.CurrentStepIndex;

    this.transferEmployerCloseOfficeService.getSelectableOfficesAndSelectableEmployees(this.workflow.WorkflowID).subscribe(
      (resp: GetEmployeesAndOfficesToSelectToManageModel) => {
        console.log("selectableList ", resp);
        this.EmployeeList = resp.EmployeeList;
        this.OfficeList = resp.OfficeList;

      });

    this.currentPageWatcher.pageChanged().emit(this.title);

  }


  selectAll() {
    for (var i = 0; i < this.EmployeeList.length; i++) {
      if(this.EmployeeList[i].IsSelectable){
        this.EmployeeList[i].selected = this.selectedAll;
      }
    }
  }
  checkIfAllSelected() {
    this.selectedAll = this.EmployeeList.every(function (item: any) {
      return item.selected == true;
    })
  }

  onSever() {
    if (this.sever == false) {
      this.sever = true;

    }

    else {
      //You must select one or more employees to sever.
      this.currentPageWatcher.sendUserMessages(null);

      this.selectEmployeesModel.EmploymentID = this.EmployeeList.filter(element => element.selected).map(element => element.EmploymentID);
      if (this.selectEmployeesModel.EmploymentID.length == 0) {
        let messageModel: MessageModel = {};
        messageModel.Alert = 3;
        messageModel.Description = "You must select one or more employees to sever.";
        this.userMessages.push(messageModel);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        this.userMessages = [];
        this.transfer = false;
        this.sever = false;
      }

      else {
        console.log(this.selectEmployeesModel);
        this.transferEmployerCloseOfficeService.submitListOfEmployment(this.selectEmployeesModel).subscribe(
          (resp: SelectEmployeesToManageResponseModel) => {
            this.selectEmployeesToManageResponseModel = resp;
            this.updatedWorkflow = resp.Workflow;
            resp.UserMessages.forEach(msg => {
              this.userMessages.push(msg);
            })
            this.currentPageWatcher.sendUserMessages(this.userMessages);
            $("html, body").animate({ scrollTop: 0 }, "slow");

            if (resp.Summary == 0) {
              this.transferEmployerCloseOfficeService.getSelectableOfficesAndSelectableEmployees(this.workflow.WorkflowID).subscribe(
                (res: GetEmployeesAndOfficesToSelectToManageModel) => {
                  console.log("new list after the second get ", res);
                  this.EmployeeList = res.EmployeeList;
                });
              this.userMessages = [];
              this.severSubmitted = true;
            }
            if (resp.Summary == 1) {
              $("html, body").animate({ scrollTop: 0 }, "slow");
              this.userMessages = [];
            }
            if (resp.Summary == 2) {
              this.router.navigate(["/home"]).then(() => {

              });
              this.userMessages = [];
            }
          })

      }
      this.sever = false;

    }

  }

  onTransfer() {
    if (this.transfer == false) {
      this.transfer = true;

    }

    else {
      this.currentPageWatcher.sendUserMessages(null);
      console.log("this.selectEmployeesModel.EntityID ", this.selectEmployeesModel.EntityID)
      this.selectEmployeesModel.EmploymentID = this.EmployeeList.filter(element => element.selected).map(element => element.EmploymentID);
      if (this.selectEmployeesModel.EntityID == null) {
        let messageModel: MessageModel = {};
        messageModel.Alert = 3;
        messageModel.Description = "You must select an office to transfer the selected employees to.";
        this.userMessages.push(messageModel);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        this.userMessages = [];
        this.transfer = false;
        this.sever = false;
      }
      if ((this.selectEmployeesModel.EmploymentID.length == 0) || (this.selectEmployeesModel.EmploymentID.length == 0 && this.selectEmployeesModel.EntityID == null)) {
        let messageModel: MessageModel = {};
        messageModel.Alert = 3;
        messageModel.Description = "You must select one or more employees to transfer.";
        this.userMessages.push(messageModel);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        this.userMessages = [];
        this.transfer = false;
        this.sever = false;
      }
      else {
        this.transferEmployerCloseOfficeService.submitListOfEmployment(this.selectEmployeesModel).subscribe(
          (resp: SelectEmployeesToManageResponseModel) => {
            this.selectEmployeesToManageResponseModel = resp;
            this.updatedWorkflow = resp.Workflow;
            resp.UserMessages.forEach(msg => {
              this.userMessages.push(msg);
            })
            this.currentPageWatcher.sendUserMessages(this.userMessages);
            $("html, body").animate({ scrollTop: 0 }, "slow");

            if (resp.Summary == 0) {
        this.transferEmployerCloseOfficeService.getSelectableOfficesAndSelectableEmployees(this.workflow.WorkflowID).subscribe(
          (res: GetEmployeesAndOfficesToSelectToManageModel) => {
            console.log("new list after the second get ", res);
            this.selectEmployeesModel.EntityID = null;
            this.EmployeeList = res.EmployeeList;
            this.OfficeList = res.OfficeList;
            this.transferSubmitted = true;

          });
        this.userMessages = [];
        }
        if (resp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (resp.Summary == 2) {
          this.router.navigate(["/home"]).then(() => {

          });
          this.userMessages = [];
        }
         })


      }
      this.transfer = false;
      this.sever = false;
    }

  }
  cancel() {
    this.sever = false;
    this.transfer = false;
    this.selectedAll =false;
    for (var i = 0; i < this.EmployeeList.length; i++) {
    
        this.EmployeeList[i].selected = false;
    }
    for (var i = 0; i < this.OfficeList.length; i++) {
    
      this.OfficeList[i].selected = false;
  }
  }

  open(indivID: number) {
    const modalRef = this.modalService.open(IndividualLicenseComponent);
    modalRef.componentInstance.indivID = indivID;
  }

  continue() {
    this.currentPageWatcher.sendUserMessages(null);
    console.log(this.selectEmployeesModel);
    
        let stepsList : Array<WorkflowStepModel> = [];
      
        if (this.updatedWorkflow!=undefined && this.updatedWorkflow!=null && this.updatedWorkflow.Steps!=undefined) {

          //update steps in localstorage with new workflow response
         this.updatedWorkflow.Steps.forEach(el => {
            let step = this.storage.getStartFunctionData().Workflow.Steps.find(i => i.WorkflowStepType===el.WorkflowStepType)
            if(step){
              el.checked = step.checked;
            }
            else{
              el.checked=false;
  
            }
  
            stepsList.push(el);
          });
  
          this.startFunction.Workflow.Steps = stepsList;
  
          this.storage.setStartFunctionData(this.startFunction);
        }

        if(this.selectEmployeesToManageResponseModel==undefined || this.selectEmployeesToManageResponseModel==null){
          let userMessage: MessageModel = {};
          userMessage.Alert = 3;
          userMessage.Description = "You must sever or transfer at least one employee before continuing.";
          this.userMessages.push(userMessage);
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          this.userMessages = [];
        }
        else{
          this.router.navigate(["/listCancelActions"]).then(() => {
            this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(this.searchEmployeesToManageResponseModel);
            this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);
            this.transferEmployerCloseOfficeService.getNotifyEmployeeSelectableList().emit(this.EmployeeList);
            this.transferEmployerCloseOfficeService.getNotifySelectEmployeesToManageResponseModel().emit(this.selectEmployeesToManageResponseModel);
            this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
            this.startFunctionService.getNotifyStepInProgress().emit(true);
          });
        }
          
  }

  goBack() {
    this.currentPageWatcher.sendUserMessages(null);
    this.router.navigate(["/searchEmployees"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);

    })

  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();

  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/select-employees/select-employees.component.ts